import React from "react";
import styled from "styled-components";

import { ResponsiveContainer } from "./responsive-container";

type ArticleSection = {
  title: string;
  content: React.ReactNode;
};

type ArticlePageProps = {
  mainTitle: string;
  intro: string;
  sections: ArticleSection[];
};

export const ArticlePage = ({ mainTitle, intro, sections }: ArticlePageProps) => (
  <Page>
    <section className="article-details-page">
      <div className="article-details-page__header">
        <div className="article-content">
          <h1 className="article-content__title">{mainTitle}</h1>
          <p>{intro}</p>
        </div>
      </div>
      <div className="article-details-content">
        {sections.map((section, index) => (
          <div key={index}>
            <h2 className="article-details-content__title">{section.title}</h2>
            {section.content}
          </div>
        ))}
      </div>
    </section>
  </Page>
);

const Page = styled(ResponsiveContainer)`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  padding: 0;
  margin: 0;
`;
